module.exports = __webpack_public_path__ + "static/media/totem.47299430.gif";